module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Bold.52541b09.otf";